
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/direct-mail-for-roofers",
      function () {
        return require("private-next-pages/direct-mail-for-roofers.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/direct-mail-for-roofers"])
      });
    }
  